"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animateRotateConfig = void 0;
var _collapsible = require("../animation/collapsible");
const animateRotateConfig = {
  property: 'rotate',
  easing: _collapsible.easing,
  duration: _collapsible.inDuration
};
exports.animateRotateConfig = animateRotateConfig;